/**
 * WithdrawAccountSection Component
 * 출금 모달용 계좌 정보 표시 섹션 (출금계좌 우선 표시)
 */
import React from 'react';
import {
    WithdrawAccountInfo,
    WithdrawableAmount,
    ACCOUNT_ROW_STYLE,
    getWithdrawAccountString,
    getDepositAccountString,
    hasDepositAccount
} from './withdrawModal.helpers';

interface WithdrawAccountSectionProps {
    /** 계좌 정보 */
    accountInfo: WithdrawAccountInfo;
    /** 출금 가능 금액 정보 */
    withdrawableAmount: WithdrawableAmount;
}

const WithdrawAccountSection: React.FC<WithdrawAccountSectionProps> = ({
    accountInfo,
    withdrawableAmount
}) => {
    const withdrawAccount = getWithdrawAccountString(accountInfo, withdrawableAmount);
    const depositAccount = getDepositAccountString(accountInfo, withdrawableAmount);
    const showDepositAccount = hasDepositAccount(accountInfo, withdrawableAmount);

    return (
        <div className="account-info">
            <div style={ACCOUNT_ROW_STYLE}>출금계좌 {withdrawAccount}</div>
            {showDepositAccount && <div>입금계좌 {depositAccount}</div>}
        </div>
    );
};

export default WithdrawAccountSection;
